import * as vp from 'vopay';
import { FunctionComponent, useContext, useMemo } from 'react';
import { createPortal } from 'react-dom';
import { DialogueHandler, LogoutDialogueHandler } from './types';
import LogoutDialogueContext from './LogoutContext';
import { useTranslation } from 'react-i18next';

const { ConfirmationDialogue } = vp;

type LogoutDialogueProps = {
  handleDialogue: DialogueHandler<LogoutDialogueHandler>;
};

type FC = FunctionComponent<LogoutDialogueProps>;

const LogoutDialogue: FC = ({ handleDialogue }: LogoutDialogueProps) => {
  const { showLogoutAlert, isSuspiciousLogin } = useContext(LogoutDialogueContext);
  const { t } = useTranslation('translations', { keyPrefix: 'Login.LogoutDialog' });

  const Title = isSuspiciousLogin ? t('SuspiciousLogin.title') : t('title');

  const SubTitle = isSuspiciousLogin ? t('SuspiciousLogin.subTitle') : t('subTitle');

  // Portal to document.body so the Modal's position:fixed overlay is sized against
  // the viewport. Rendered in place, it sits inside the login Card, whose
  // `filter: drop-shadow` establishes a containing block that clips the backdrop to
  // the card box instead of the full screen (ID-12943).
  return useMemo(
    () =>
      createPortal(
        <ConfirmationDialogue
          isVisible={showLogoutAlert}
          title={Title}
          status="error"
          subTitle={SubTitle}
          confirm={{
            label: t('closeButton'),
            action: () => handleDialogue({ type: 'error', state: 'confirm' }),
          }}
        />,
        document.body,
      ),
    [showLogoutAlert],
  );
};

export default LogoutDialogue;
